import { getLocale } from "../runtime";

const da_searchresultfor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Viser resultater for`
};

const en_searchresultfor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Showing results for`
};

const es_searchresultfor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Mostrando resultados para`
};

const fi_searchresultfor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Näytetään tulokset haulle`
};

const nb_searchresultfor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Viser resultater for`
};

const sv_searchresultfor = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Visar resultat för`
};

const searchresultfor = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_searchresultfor(inputs)
	if (locale === "en") return en_searchresultfor(inputs)
	if (locale === "es") return es_searchresultfor(inputs)
	if (locale === "fi") return fi_searchresultfor(inputs)
	if (locale === "nb") return nb_searchresultfor(inputs)
	if (locale === "sv") return sv_searchresultfor(inputs)
	return "searchResultFor";
};

export { searchresultfor as "searchResultFor" };